import clsx from "clsx";
import { LabelHTMLAttributes, ReactNode } from "react";
import * as styles from "./Label.css";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /**
   * The main label text
   */
  label: string;
  /**
   * Optional text displayed next to the label
   */
  optionalText?: ReactNode;
  /**
   * Whether the label is disabled
   */
  disabled?: boolean;
}

export function Label({ label, optionalText, ...props }: LabelProps) {
  return (
    <div
      className={clsx(
        styles.labelRow,

        props.disabled && styles.labelDisabled
      )}
    >
      <label {...props}>{label}</label>
      {optionalText && (
        <span
          className={clsx(
            styles.optionalText,
            props.disabled && styles.labelOptionalDisabled
          )}
        >
          {optionalText}
        </span>
      )}
    </div>
  );
}
